import {
  ButtonBase,
  Tooltip as MuiTooltip,
  TooltipProps,
  Zoom,
} from "@mui/material";

const Tooltip = ({ title, children, ...props }: TooltipProps) => {
  return (
    <MuiTooltip
      title={title}
      arrow
      placement="top"
      TransitionComponent={Zoom}
      sx={{}}
      {...props}
    >
      <ButtonBase sx={{ height: "fit-content" }}>{children}</ButtonBase>
    </MuiTooltip>
  );
};

export default Tooltip;
